import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { ModalService } from '@app/services/modal/modal.service';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'mnf-modal-view-projects',
  templateUrl: './modal-view-projects.component.html',
  styleUrls: ['./modal-view-projects.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalViewProjectsComponent implements OnInit {

  /** Variable global de proyectos actuales */
  actualProjects: any;

  /** Iconos */
  arrowDownIcon = faChevronDown;
  arrowUpIcon = faChevronUp;
  
  /** Imagen Default en caso de no tener ninguna cargada */
  defaultImage = 'assets/monific/logo-monific-mob.svg';

  /** RegExp Monific Bucket */
  monificBase = new RegExp('monificbucket-dev.s3');

  /** Variables para calcular el monto fondeado actualmente */
  fundingNow: any;

  /** Variable para mostrar información desgloada de gastos */  
  indexToShowInfo: number = -1;

  
  constructor() { }

  ngOnInit(): void {
  }

  /** Función para obtener la imagenes de los proyectos con las URL's */
  getFileUrl(idProject: string, file: string): any {
    return environment.apiUrlBase + '/developer/fl/req/' + idProject + '/' + file;
  }

  /** Función para establecer el indice de la información activa */
  setActiveIndex(i: number) {
    if (this.indexToShowInfo === i) {
      this.indexToShowInfo = -1;      
    } else {
      this.indexToShowInfo = i
    }
  }

}
